var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_727",
    "data-name": "Group 727",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.99,
    height: 26.006,
    viewBox: "0 0 25.99 26.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M822.636,415.91q0-4.338,0-8.675a4.069,4.069,0,0,1,4.292-4.3q6.012,0,12.024,0a4.062,4.062,0,0,1,4.28,4.261q.01,3.7,0,7.407c0,.686-.306,1.109-.848,1.2a1.025,1.025,0,0,1-1.179-1.121c-.008-2.3-.067-4.6.016-6.9.072-1.966-.779-2.888-2.851-2.844-3.769.08-7.542.022-11.313.023a2.1,2.1,0,0,0-2.391,2.4q0,8.574,0,17.148a2.092,2.092,0,0,0,2.362,2.374q3.019,0,6.037,0a1.075,1.075,0,0,1,1.063.546.989.989,0,0,1-.838,1.475c-2.333.023-4.671.08-7-.025a3.96,3.96,0,0,1-3.651-3.987C822.623,421.9,822.636,418.9,822.636,415.91Z",
    transform: "translate(-822.631 -402.932)",
    fill: "#2d335d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M970.159,541.753a3.1,3.1,0,0,1-.9,2.247q-2.719,2.728-5.456,5.438a1.689,1.689,0,0,1-.685.4c-1.28.374-2.566.726-3.854,1.071a1.014,1.014,0,0,1-1.306-1.349q.55-1.9,1.148-3.778a1.648,1.648,0,0,1,.394-.634c1.809-1.822,3.619-3.645,5.452-5.442a2.887,2.887,0,0,1,3.364-.643A2.929,2.929,0,0,1,970.159,541.753Zm-5.444,1.012c-1.06,1.071-2.079,2.177-3.183,3.19-.754.692-.772,1.617-1.14,2.536.506-.138.891-.272,1.286-.344a2.467,2.467,0,0,0,1.365-.8c.926-.962,1.885-1.892,2.829-2.837.1-.1.191-.217.258-.294Zm2.927-.041c.587-.575.627-1.205.123-1.638a.979.979,0,0,0-1.5.258Z",
    transform: "translate(-944.169 -524.999)",
    fill: "#2d335d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M865.269,504.967c.68-.823,1.292-1.564,1.905-2.3a5.408,5.408,0,0,1,.364-.422,1,1,0,0,1,1.376-.079.957.957,0,0,1,.162,1.363c-.82,1.031-1.646,2.06-2.527,3.039a1.677,1.677,0,0,1-2.417.075,15.253,15.253,0,0,1-1.139-1.154,1.007,1.007,0,1,1,1.431-1.418C864.7,504.33,864.954,504.63,865.269,504.967Z",
    transform: "translate(-858.621 -491.877)",
    fill: "#2d335d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M865.271,443.57c.658-.8,1.28-1.551,1.9-2.3a4.405,4.405,0,0,1,.4-.456,1.006,1.006,0,0,1,1.342-.022.935.935,0,0,1,.192,1.281c-.86,1.087-1.726,2.173-2.665,3.19a1.657,1.657,0,0,1-2.343-.024,15.827,15.827,0,0,1-1.134-1.161.988.988,0,0,1,.012-1.414,1.007,1.007,0,0,1,1.453.033C864.715,442.96,864.97,443.254,865.271,443.57Z",
    transform: "translate(-858.614 -436.725)",
    fill: "#2d335d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M865.218,565.522c.686-.831,1.308-1.586,1.933-2.339a4.313,4.313,0,0,1,.4-.455,1,1,0,0,1,1.342-.017.935.935,0,0,1,.185,1.282c-.86,1.086-1.726,2.171-2.664,3.189a1.634,1.634,0,0,1-2.264.036,13.47,13.47,0,0,1-1.249-1.259.976.976,0,0,1,.051-1.375.989.989,0,0,1,1.377-.027C864.641,564.84,864.9,565.174,865.218,565.522Z",
    transform: "translate(-858.585 -546.273)",
    fill: "#2d335d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M938.786,469.409c-.488,0-.978.016-1.465,0a1,1,0,0,1-1.049-1,.983.983,0,0,1,1.027-1.017c.976-.024,1.954-.022,2.93,0a1,1,0,0,1,1.053,1,1.017,1.017,0,0,1-1.082,1.022C939.73,469.423,939.258,469.409,938.786,469.409Z",
    transform: "translate(-924.74 -460.832)",
    fill: "#2d335d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M938.776,530.921c-.472,0-.944.01-1.415,0a1,1,0,0,1-1.076-1.023.993.993,0,0,1,1.046-1c.977-.015,1.955-.016,2.932,0a1,1,0,0,1,1.031,1.019,1.013,1.013,0,0,1-1.052,1C939.753,530.933,939.264,530.921,938.776,530.921Z",
    transform: "translate(-924.751 -516.103)",
    fill: "#2d335d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.762f1298273715edfe369cb3539b766d.svg";
export { ForwardRef as ReactComponent };